import React from 'react'

import './Copyright.css'

const Copyright = () => <p className="copyright">Copyright &copy; 2022 Oneconduck, Owner.</p>

export default Copyright
